
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsAuthLoading, getToken } from '../../reducers/auth';
import {
    getProject,
    getIsProjectLoaded,
    getNeedLoadProject
} from '../../reducers/project';
import projectGetActions from '../../sagas/project';

import AnalyzeDefunctParPageView from './AnalyzeDefunctParPage.view';

const AnalyzeDefunctParPageState = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));

    const projectIdFromUrl = props.match.params.id;

    const project = useSelector(state => getProject(state.project));
    const needLoadProject = useSelector(state =>
        getNeedLoadProject(state.project, projectIdFromUrl, getIsAuthLoading(state.auth))
    );
    const isProjectLoaded = useSelector(state => getIsProjectLoaded(state.project, projectIdFromUrl));

    React.useEffect(() => {
        if (needLoadProject) {
            projectActions.loadProject(token, projectIdFromUrl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [needLoadProject]);

    return (
        <AnalyzeDefunctParPageView
            project={isProjectLoaded ? project : null}
        />
    )
}

export default AnalyzeDefunctParPageState;
